<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2253"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2257"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2267"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2265" /></clipPath></defs><g
     id="g2259"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2261"><g
         id="g2263"
         clip-path="url(#clipPath2267)"><g
           id="g2269"
           transform="translate(326.2842,143.2891)"><path
             d="m 0,0 -182.995,182.996 c -33.428,-15.895 -74.5,-10.353 -102.169,17.316 -27.669,27.668 -33.21,68.741 -17.316,102.168 l 59.743,-59.742 h 42.425 v 42.427 l -59.742,59.742 c 33.428,15.894 74.5,10.353 102.169,-17.316 27.669,-27.669 33.21,-68.741 17.317,-102.169 L 42.427,42.426 c 33.427,15.895 74.5,10.353 102.169,-17.316 27.669,-27.669 33.21,-68.741 17.316,-102.169 l -59.743,59.743 H 59.743 v -42.427 l 59.742,-59.742 C 86.058,-135.379 44.985,-129.838 17.316,-102.169 -10.353,-74.5 -15.894,-33.428 0,0 Z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="path2271" /></g><g
           id="g2273"
           transform="translate(265.9189,181.0659)"><path
             d="m 0,0 -148.492,-148.492 c -23.432,-23.432 -61.422,-23.432 -84.854,0 -23.43,23.431 -23.43,61.421 0,84.852 L -84.853,84.853"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="path2275" /></g><g
           id="g2277"
           transform="translate(138.6396,138.6396)"><path
             d="M 0,0 -106.066,-106.066"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="path2279" /></g><g
           id="g2281"
           transform="translate(380.3271,380.3271)"><path
             d="M 0,0 -103.114,-103.114"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="path2283" /></g><g
           id="g2285"
           transform="translate(475.7871,497)"><path
             d="m 0,0 21.213,-21.213 -42.427,-84.853 -74.246,-10.607 10.606,74.247 z"
             style="stroke:#000000;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
             id="path2287" /></g></g></g></g></svg>
</template>
